import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import useFlags from '@/hooks/useFlags';
import styles from './NavigationCard.module.scss';
import LibraryLinks from './LibraryLinks';
import { NotebookLinks } from './NotebookLinks';
import { ApolloProvider } from '../ApolloClient';

const navigationCardStyles = tv({
  base: `card disabled ${styles.navigationCard}`,
  variants: {
    reflow: {
      true: 'tw-w-fit',
    },
  },
});

const NavigationCard = ({ cardTitle, programId, lessonId, unitId, civicsLibraryEnabled, primarySourceLibraryEnabled }) => {
  const { accessibilityReflow } = useFlags();

  const renderLinks = () => {
    if (cardTitle === 'libraries') {
      return (
        <LibraryLinks
          civicsLibraryEnabled={civicsLibraryEnabled}
          lessonId={lessonId}
          primarySourceLibraryEnabled={primarySourceLibraryEnabled}
          programId={programId}
          unitId={unitId}
        />
      );
    }

    if (cardTitle === 'unit_projects') {
      return (
        <ApolloProvider>
          <NotebookLinks
            programId={programId}
            unitId={unitId}
          />
        </ApolloProvider>
      );
    }

    return '';
  };

  return (
    <div className={navigationCardStyles({ reflow: accessibilityReflow })} role="group">
      <div className={styles.cardHeader}>
        <h2 className={styles.cardTitle}>{I18n.t(cardTitle === 'libraries' ? 'libraries.title' : cardTitle)}</h2>
        <hr />
        {renderLinks()}
      </div>
    </div>
  );
};

NavigationCard.defaultProps = {
  civicsLibraryEnabled: false,
  primarySourceLibraryEnabled: false,
  unitId: 0
};

NavigationCard.propTypes = {
  cardTitle: PropTypes.string.isRequired,
  civicsLibraryEnabled: PropTypes.bool,
  lessonId: PropTypes.number,
  primarySourceLibraryEnabled: PropTypes.bool,
  programId: PropTypes.number.isRequired,
  unitId: PropTypes.number,
};

export default NavigationCard;
